module.exports = __webpack_public_path__ + "static/media/tut-8-1.86ffa28b.png";